import Grid from "@mui/material/Grid";
import DateFilterStyle from "./DateFilterStyle";
import React from "react";
import { Typography } from "@mui/material";
import DateRangePicker from "../DateRange/DateRange";

export default function DateFilter() {
  const classes = DateFilterStyle();
  return (
    <Grid container className={classes.dateFilterBar}>
      <Grid item alignItems="center" container xs={12} md={12}>
        <Typography className={classes.headerText}>Arrival date :</Typography>
        <DateRangePicker />
      </Grid>
    </Grid>
  );
}
